module.exports = __webpack_public_path__ + "signIn-jAQ.png";